"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackRow = exports.InstructionRow = exports.OptionRow = exports.Option = exports.Exercise = exports.StudentAssignment = void 0;
class StudentAssignment {
    /** @internal */
    constructor({ assignmentSnap, bubbleSnaps, id, parent, }) {
        this.assignmentSnap = assignmentSnap;
        this.bubbleSnaps = bubbleSnaps;
        this._id = id;
        this.parent = parent;
    }
    get id() {
        return this._id;
    }
    /**
     * The progress of this exercise. The values are between 0 and 100
     */
    get progress() {
        return this.assignmentSnap.get("progress");
    }
    get finished() {
        return this.assignmentSnap.get("finished");
    }
    /**
     * Tells you when Amy is ready with setting up the exercises for this assignment
     */
    get ready() {
        return this.exercises.length > 0;
    }
    get exercises() {
        const r = [];
        const exIds = this.assignmentSnap.get("exercises").map((e) => e.studentExerciseId);
        for (const exId of exIds) {
            const ex = this.assignmentSnap.get("exercises").find((e) => e.studentExerciseId === exId);
            const aex = new Exercise({
                id: exId,
                finished: ex.state === "FINISHED",
                parent: this,
            });
            r.push(aex);
            const rawRows = this.bubbleSnaps.docs.filter((e) => e.get("studentExerciseId") === exId);
            for (const r of rawRows) {
                if (r.get("type") === "QUESTION") {
                    aex.rows.push(new InstructionRow({ id: r.id, text: r.get("text") }));
                }
                else if (r.get("type") === "FEEDBACK") {
                    aex.rows.push(new FeedbackRow({ id: r.id, text: r.get("text") }));
                }
                else if (r.get("type") === "OPTION") {
                    const or = new OptionRow({
                        id: r.id,
                        correct: r.get("correct") ? "YES" : r.get("correct") === false ? "NO" : "UNKNOWN",
                        parent: aex,
                    });
                    r.get("selectedPath");
                    for (const o of r.get("options")) {
                        const selected = r.get("selectedPath") === o.path;
                        or.options.push(new Option({ id: o.path, text: o.text, selected, parent: or }));
                    }
                    aex.rows.push(or);
                }
            }
        }
        return r;
    }
    getExerciseById(exerciseId) {
        return this.exercises.find((e) => e.id === exerciseId);
    }
    getFirstUnfinishedExercise() {
        return this.exercises.find((e) => e.finished === false);
    }
}
exports.StudentAssignment = StudentAssignment;
class Exercise {
    /** @internal */
    constructor({ id, finished = false, parent }) {
        this.rows = [];
        this._id = id;
        this._finished = finished;
        this.parent = parent;
    }
    get id() {
        return this._id;
    }
    get finished() {
        return this._finished;
    }
    /**
     * Convenience function filtering through all rows and returning the one that has an UNKNOWN state
     */
    get lastSelectableRow() {
        return this.rows.filter((e) => e instanceof OptionRow).find((e) => e.correct === "UNKNOWN");
    }
}
exports.Exercise = Exercise;
class Option {
    constructor({ id, text, selected, parent }) {
        this.id = id;
        this.text = text;
        this.selected = selected;
        this.parent = parent;
    }
    /**
     * Selects (click) a given option
     *
     * @returns Returns a promise indicating if the selection was correct or incorrect
     * @throws Will throw an error if selected option was already selected, or a rows state is already known.
     */
    async select() {
        //
        console.log(`/assignment/${this.parent.parent.parent.id}/row/${this.parent.id}/option/${this.id} selected`);
        if (this.parent.correct !== "UNKNOWN") {
            throw new Error("Row was already selected");
        }
        await this.parent.parent.parent.parent.firebaseApp
            .firestore()
            .collection("ExerciseBubbles")
            .doc(this.parent.id)
            .update({
            selectedPath: this.id,
        });
        return new Promise((resolve) => {
            const stopListenter = this.parent.parent.parent.parent.firebaseApp
                .firestore()
                .collection("ExerciseBubbles")
                .doc(this.parent.id)
                .onSnapshot((snap) => {
                if (snap.get("correct") !== null) {
                    stopListenter();
                    resolve(snap.get("correct"));
                }
            });
        });
    }
}
exports.Option = Option;
class OptionRow {
    constructor({ id, correct, parent }) {
        this.correct = "UNKNOWN";
        this.options = [];
        this.id = id;
        this.correct = correct;
        this.parent = parent;
    }
}
exports.OptionRow = OptionRow;
class InstructionRow {
    constructor({ id, text }) {
        this.id = id;
        this.text = text;
    }
}
exports.InstructionRow = InstructionRow;
class FeedbackRow {
    constructor({ id, text }) {
        this.id = id;
        this.text = text;
    }
}
exports.FeedbackRow = FeedbackRow;
//# sourceMappingURL=StudentAssignment.js.map